$(function(){

var form_id = '#careerForm'; // form の id名


  // 入力項目の検証ルール定義

  var rules = {
    job: { // 希望職種
      required: true
    },
    fullName: { // 名前
      required: true
    },
    gender: { // 性別
      required: true
    },
    age: { // 年齢
      required: true
    },
    zip: { // 郵便番号
      required: true
    },
    address: { // 住所
      required: true
    },
    tel: { // 電話番号
      required: true,
      tel: true
    },
    email: { // メールアドレス
      required: true,
      mail: true
    }
  }; // var rules

  // 入力項目ごとのエラーメッセージ定義
  var messages = {
    job: { // 希望職種
      required: "入力してください"
    },
    fullName: { // 名前
      required: "入力してください"
    },
    gender: { // 性別
      required: "選択してください"
    },
    age: { // 年齢
      required: "入力してください"
    },
    zip: { // 郵便番号
      required: "入力してください"
    },
    address: { // 住所
      required: "入力してください"
    },
    tel: { // 電話番号
      required: "入力してください",
      tel: "正しい電話番号を入力してください"
    },
    email: { // メールアドレス
      required: "入力してください",
      mail: "正しいメールアドレスを入力してください"
    }
  }; // var messages

  // 追加ルールの定義
  var methods = {
    tel: function tel( value, element ) {
      // 電話番号のバリデーション
      return this.optional(element) || /^\d{10,11}$/.test(value);
    },
    mail: function mail( value, element ) {
      // メールアドレスのバリデーション
      return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    }
  };

  //メソッドの追加（上記の追加ルールを適用させる）
  $.each( methods, function( key ) {
    $.validator.addMethod( key, this );
  });

  // jQuery Validation Plugin の初期化
  $( form_id ).validate({
    rules    : rules,
    messages : messages,
    // 複数項目のグループ化
    groups: {
      fullPossible: 'possibleYear possibleMonth possibleDay'
    },
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element )
    {
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element )
    {
      var eleName = '#' + element.attr('name');
      error.prependTo( eleName + '_error' );

      /*if ( element.attr('name') == 'zip' || element.attr('name') == 'address' ) {
        error.prependTo('#address_error');
      } else {
        error.prependTo( eleName + '_error' );
      }*/
    }
  }); // チェックボックスの validation 発火

  $('input[type="checkbox"]').on('click', function () {
    $('form').validate().element(this);
  });

}); // $(function()
